import { render, staticRenderFns } from "./RequestMonitoringBulkCreate.vue?vue&type=template&id=618cf3c6&scoped=true&"
import script from "./RequestMonitoringBulkCreate.vue?vue&type=script&lang=js&"
export * from "./RequestMonitoringBulkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cf3c6",
  null
  
)

export default component.exports